<template>
  <el-dialog width="760px" :close-on-click-modal="false" :visible="ruleListShow" @close="beforeClose" class="dialog-dark">
    <template slot="title">
      <div class="rule-list-head">
        <div>{{$t('ruleList.直播违规画面')}}</div>
		<i class="el-icon-refresh-right refresh-list" @click="refreshList"></i>
		<!-- <i class="refresh-list" @click="refreshList"></i> -->
      </div>
    </template>
    <template>
		<div class="my-table">
		<el-table :data="ruleList" style="width: 100%" ref="listTable" height="430" class="custom-table">
			<el-table-column prop="picture" :label="$t('ruleList.违规画面')" align="center">
				<template slot-scope="scope">
					<el-image :src="scope.row.picture" fit="fill" :preview-src-list="[scope.row.picture]" class="image-content">
						<template #viewer-action>
              				<i class="el-icon-circle-close outline-icon" @click="closeViewer"></i>
            			</template>
					</el-image>
				</template>
			</el-table-column>
			<el-table-column
				prop="tripartiteResult"
				:label="$t('ruleList.审核结果')"
				align="center"
				class-name="result-cell"
				:formatter="resultFormatter">
				</el-table-column>
				<el-table-column prop="tripartiteRiskLabel" :label="$t('ruleList.风险类型')" align="center">
					<template slot-scope="scope">
						{{ scope.row.tripartiteRiskLabel.map(label => riskTypes[label]).join(', ') }}
					</template>
				</el-table-column>
			<el-table-column prop="pictureTimestamp" :label="$t('ruleList.截取时间')" width="150" align="center"></el-table-column>
			<el-table-column prop="timestamp" :label="$t('ruleList.发送时间')" width="150" align="center"></el-table-column>
			<el-table-column prop="tripartiteTimestamp" :label="$t('ruleList.反馈时间')" width="150" align="center"></el-table-column>
	  	</el-table>
		</div>
	</template>
    <template slot="footer"></template>
  </el-dialog>
</template>
<script>
import { tripartiteLsit } from '@/api/liveRequest/liveInfo';
import { mapGetters } from "vuex";
import { getParameter } from "@/utils/global";
import riskTypes from './riskTypes.js'
import Bus from "@/components/doc/bus";
export default {
  props: {
    ruleListShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
		ruleList: [
		],
		loading: false, // 是否正在加载
    	noMoreData: false, // 是否已加载完所有数据
		lists:[],
		maxClicksPerMinute: 6, // 允许的最大点击次数
		numOfClicks:0, // 当前的点击次数
		lastId: "", //最后一条数据id
		limit: '10',
		liveId: getParameter("liveId"),
		riskTypes
    }
  },
  computed: {
	...mapGetters([
      "liveToken",
	  "confId"
    ])
  },
  watch: {
   
  },
  mounted(){
	this.$nextTick(()=>{
		this.fetchList();
		let tableBodyWrapper = this.$refs.listTable.$el.querySelector('.el-table__body-wrapper');
		if (tableBodyWrapper) {
			tableBodyWrapper.addEventListener('scroll', this.handleScroll);
		}
	})
  },
  created() {
	Bus.$on("lists", () => {
		this.ruleList = [];
		this.lists = [];
		this.lastId = "";
		this.loading = false;
		this.fetchList();
		let tableBodyWrapper = this.$refs.listTable.$el.querySelector('.el-table__body-wrapper');
		if (tableBodyWrapper) {
			tableBodyWrapper.addEventListener('scroll', this.handleScroll);
		}
	});
  },
  beforeDestroy() {
    let tableBodyWrapper = this.$refs.listTable.$el.querySelector('.el-table__body-wrapper');
    if (tableBodyWrapper) {
        tableBodyWrapper.removeEventListener('scroll', this.handleScroll);
    }
	Bus.$off("lists");
  },
  methods: {
	resultFormatter(row, column, cellValue) {
      switch (cellValue) {
        case 'VALIDATE':
          return this.$t('ruleList.疑似');
        case 'REJECT':
          return this.$t('ruleList.不合规');
        default:
          return cellValue;
      }
    },
    beforeClose() {
      this.$emit("update:ruleListShow", false)
    },
	closeViewer() {
      // 关闭预览
      this.$refs.imageViewer.viewer.hide();
    },
	// 在一分钟后重置点击次数
	resetClicks(){
		setTimeout(() => {
			this.numOfClicks = 0;
		}, 60 * 1000);
	},
	refreshList() {
		this.numOfClicks += 1;
		if (this.numOfClicks === 1) {
			this.resetClicks();
		}
		if (this.numOfClicks > this.maxClicksPerMinute) {
			this.$alert(`${this.$t('ruleList.您点击的太频繁了')}`);
		} else {
			this.ruleList = [];
			this.lists = [];
			this.lastId = "";
			this.loading = false;
			this.fetchList();
		}
	},
	fetchList() {
		try {
			tripartiteLsit({
				limit: this.limit,
				maxObjectId: this.lastId,
				status: '0',
				webcastId: this.liveId,
				confId: this.confId
			}, this.liveToken).then(res => {
				if (res.code === 200) {
					this.lists = res.data;
					this.ruleList = [...this.ruleList, ...this.lists];
					this.loading = false;
					this.lastId = this.lists[this.lists.length -1].objectId;
					console.log(this.lists,'返回....')
					if (this.lists.length < this.limit) {
						console.log(this.lists.length,'....')
						this.noMoreData = true; // 如果获取到新数据比要显示的少，设置noMoreData为true
					} else {
						this.noMoreData = false;
					}
				} else {
					this.lists = [];
					this.loading = false;
				}
			}).catch(() => {
				this.lists = [];
				this.loading = false;
			});
		} catch(error) {
			this.lists = [];
			this.loading = false;
		}	
	},
	handleScroll(e) {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      if (scrollHeight - scrollTop - clientHeight < 5) { // 当滚动到距离底部50px时加载更多
        console.log('更多')
		this.loadMore();
      }
    },
    async loadMore() {
		console.log(this.loading, "this.loading...")
		console.log(this.noMoreData, "this.noMoreData...")
      if (this.loading || this.noMoreData) return; // 如果正在加载或已无更多数据，直接返回
      this.loading = true;
      this.fetchList(); // 从后端获取新数据
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep{
	.el-dialog__header{
		padding:5px;
	}
	// .el-dialog__close {
	// 	color: #727480;
	// }
	.el-dialog__body {
		padding: 0;
		box-sizing: border-box;
	}
	.el-table {
		font-size: 12px;
	}
	.el-table thead {
		background: #3A3D5F;
		font-size: 12px;
	}
	
	.img-rule{
		width: 64px;
		height:64px;
		cursor: pointer;
	}
	.el-table thead .el-table__cell{
		padding:0;
		color: #ACB2BF;
		line-height: 30px;
	}
	.el-table tbody tr:hover>td {
		background-color: inherit !important;
	}
	.el-table td.el-table__cell {
		color: #fff;
		border-top: 1px solid #454767;
	}
	.el-table td.result-cell {
		color: #F89B33;
	}
	.el-table tr:first-child td {
		border-top: none;
	}
}
::v-deep .el-table,
::v-deep .el-table__expanded-cell {
 background-color: transparent !important;
}
/* 表格内背景颜色 */
::v-deep .el-table th,
::v-deep .el-table tr,
::v-deep .el-table td {
 background-color: transparent !important;
 border: 0; //去除表格
}
::v-deep.el-table th.el-table__cell.is-leaf {
 border: 0;
}
/*去除底部灰条.el-table::before*/
::v-deep .el-table::before {
  display: none;
}
.refresh-list{
    display: inline-block;
	color: #adb2be;
    font-weight: 500;
    cursor: pointer;
    position: absolute;
    top: 20px;
    right: 50px;
}
.image-content{
	width:64px;
	height:36px;
}
.rule-list-head {
	color: #8A8F99;
}
</style>
<style>
.el-image-viewer__btn {
	display: none;
}
.el-image-viewer__canvas {
	max-width:1000px;
	max-height:650px;
}
.el-image-viewer__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
	z-index: 3000!important;
}
[data-theme=Orange] .el-table__header-wrapper thead{
	background: #F6F6F6;
}
[data-theme=Orange] .el-table td.el-table__cell {
	color: #3E3F41;
	border-top: 1px solid #EBEBEB;
}
[data-theme=Orange] .el-table td.result-cell {
	color: #FF595B;
}
[data-theme=Orange] .el-table tr:first-child td {
	border-top: none;
}
/* 滚动条的宽度 */
.el-table__body-wrapper::-webkit-scrollbar {
    width: 5px;
	height: 5px;
}

/* 滚动条轨道的样式 */
.el-table__body-wrapper::-webkit-scrollbar-track {
	box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	width: 4px;
	background: transparent;
}
 
/* 滚动条的样式 */
.el-table__body-wrapper::-webkit-scrollbar-thumb {
    width: 5px;
    margin: auto;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #c2c2c2;
    border-radius: 10px;
}
</style>